import PropTypes from 'prop-types';
import React from 'react';

import ErrorMessage from './ErrorMessage';

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
		};
	}

	static getDerivedStateFromError(error) {
		return { error };
	}

	componentDidCatch(error, errorInfo) {
		console.log(error, errorInfo);
	}

	render() {
		const { children } = this.props;
		const { error } = this.state;
		if (error) {
			return <ErrorMessage error={error} />;
		}
		return children;
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.node,
};

ErrorBoundary.defaultProps = {
	children: null,
};

export default ErrorBoundary;
